export interface ExportSymbol {
  symbol: string;
  exchange: string;
}

function unique(rows: readonly ExportSymbol[]): ExportSymbol[] {
  const seen = new Set<string>();
  return rows.filter((row) => {
    if (seen.has(row.symbol)) return false;
    seen.add(row.symbol);
    return true;
  });
}

/** Comma-separated tickers, the form most watchlists accept when pasted. */
export function tickerList(rows: readonly ExportSymbol[]): string {
  return unique(rows)
    .map((row) => row.symbol)
    .join(',');
}

/** One `EXCHANGE:SYMBOL` per line, the TradingView watchlist import format. */
export function tradingViewList(rows: readonly ExportSymbol[]): string {
  return unique(rows)
    .map((row) => (row.exchange ? `${row.exchange}:${row.symbol}` : row.symbol))
    .join('\n');
}

export function downloadText(fileName: string, text: string): void {
  const url = URL.createObjectURL(new Blob([text], { type: 'text/plain;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}
